import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicHooksComponent } from 'ngx-dynamic-hooks';
import { CustomContentSlice } from './custom-content.slice';

@Component({
  selector: 'app-custom-content',
  templateUrl: './custom-content.component.html',
  imports: [DynamicHooksComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomContentComponent {
  @Input() slice: CustomContentSlice;
}
